import duck1 from '../Images/avatars/duck1.png';
import duck2 from '../Images/avatars/duck2.png';
import duck3 from '../Images/avatars/duck3.png';
import duck4 from '../Images/avatars/duck4.png';
import duck6 from '../Images/avatars/duck6.png';
import duck5 from '../Images/avatars/duck5.png';
import duck7 from '../Images/avatars/duck7.png';
import duck8 from '../Images/avatars/duck8.png';
import duck9 from '../Images/avatars/duck9.png';
import duck10 from '../Images/avatars/duck10.png';
import duck11 from '../Images/avatars/duck11.png';
import duck12 from '../Images/avatars/duck12.png';
import duck13 from '../Images/avatars/duck13.png';
import duck14 from '../Images/avatars/duck14.png';
import duck15 from '../Images/avatars/duck15.png';
import duck16 from '../Images/avatars/duck16.png';
import duck17 from '../Images/avatars/duck17.png';
import duck18 from '../Images/avatars/duck18.png';
import duck19 from '../Images/avatars/duck19.png';
import duck20 from '../Images/avatars/duck20.png';

const avatars: any = [
  duck1,
  duck2,
  duck3,
  duck4,
  duck5,
  duck6,
  duck7,
  duck8,
  duck9,
  duck10,
  duck11,
  duck12,
  duck13,
  duck14,
  duck15,
  duck16,
  duck17,
  duck18,
  duck19,
  duck20,
];

export default avatars;
